import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/NotificationDrawer/notification-drawer';
import { css } from '@patternfly/react-styles';
export var NotificationDrawer = function NotificationDrawer(_a) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      props = __rest(_a, ["children", "className"]);

  return React.createElement("div", Object.assign({}, props, {
    className: css(styles.notificationDrawer, className)
  }), children);
};